// @flow
import {
    autoOpenSignUpModal,
    DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN,
    getUiDateLastShown,
    getUiModalShown,
    shouldStopAutoPopup,
} from '../../../redux/modules/autoPopModal';
import { bindActionCreators } from 'redux';
import { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import { format } from 'date-fns';
import { getOpenModal } from '../../../redux/modules/modal';
import { isUiMobile } from '../../../redux/modules/browser';
import { isUserLoggedIn } from '../../../redux/modules/user';
import { modalTypes } from '../../../enums';

const cookie = new Cookies();

const mapStateToProps = state => {
    const isMobile = Boolean(isUiMobile(state));
    const openModal = getOpenModal(state);
    const userLoggedIn = isUserLoggedIn(state);
    const modalShown = getUiModalShown(state);
    const lastDateShown = getUiDateLastShown(state);
    const preventAutoPopup = shouldStopAutoPopup(state);

    return {
        isMobile,
        lastDateShown,
        modalShown,
        openModal,
        preventAutoPopup,
        userLoggedIn,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            autoOpenSignUpModal,
        },
        dispatch
    );

type Props = {
    autoOpenSignUpModal: Function,
    isMobile: boolean,
    lastDateShown: string,
    modalShown: boolean,
    openModal: string,
    preventAutoPopup: boolean,
    userLoggedIn: boolean,
};

class AutoPopModalContainer extends Component<Props> {
    componentDidMount() {
        const { isMobile, modalShown, openModal, preventAutoPopup, userLoggedIn } = this.props;

        const shouldShowModal = !preventAutoPopup && !modalShown && openModal === modalTypes.NONE && !userLoggedIn;

        if (shouldShowModal) {
            if (isMobile) {
                // wait to attach the listener to avoid popping immediately on page load
                this.timeout = setTimeout(() => window.addEventListener('touchmove', this.onTouchMove, false), 1500);
            } else {
                this.timeout = setTimeout(() => window.addEventListener('scroll', this.onScroll, false), 1500);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const { lastDateShown, userLoggedIn, modalShown } = prevProps;

        if (!userLoggedIn && this.props.userLoggedIn) {
            const expires = new Date();
            expires.setDate(expires.getDate() + 60);
            cookie.set('bidder-has-logged-in', true, {
                domain: '.liveauctioneers.com',
                expires,
                path: '/',
            });
        }

        if ((!modalShown && this.props.modalShown) || lastDateShown !== this.props.lastDateShown) {
            const expires = new Date();
            expires.setDate(expires.getDate() + DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN);
            cookie.set('join-modal-last-seen', format(new Date(), 'yyyy-MM-dd'), {
                domain: '.liveauctioneers.com',
                expires,
                path: '/',
            });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
        window.removeEventListener('touchmove', this.onTouchMove);
        window.removeEventListener('scroll', this.onScroll);
    }

    onScroll = e => {
        e.preventDefault();
        this.props.autoOpenSignUpModal();
        window.removeEventListener('scroll', this.onScroll);
    };

    onTouchMove = e => {
        e.preventDefault();
        this.props.autoOpenSignUpModal();
        window.removeEventListener('touchmove', this.onTouchMove);
    };

    timeout: TimeoutID;

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AutoPopModalContainer);
